import { z } from "zod";
import { ufSchema } from "./calculation.js";
export const autonomousResearchScopeRouteSchema = z
    .object({ originUf: ufSchema, destinationUf: ufSchema })
    .strict();
export const autonomousResearchScopeSnapshotSchema = z
    .object({
    schemaVersion: z.literal("1.0.0"),
    policyVersion: z.literal("SP_FIRST_V1"),
    phase: z.literal("SP"),
    control: z.literal("NEW_AUTONOMOUS_SCHEDULER_WORK"),
    routes: z.array(autonomousResearchScopeRouteSchema).length(53),
    nationalDependencies: z.array(z
        .object({
        targetKey: z.string().min(1).max(200),
        dependencyOfRoutes: z.array(autonomousResearchScopeRouteSchema).min(1),
    })
        .strict()),
    coverage: z.literal("NOT_ACCREDITED"),
    contentDigest: z.string().regex(/^sha256:[a-f0-9]{64}$/),
})
    .strict();
export const autonomousResearchScopeQuerySchema = z
    .object({
    limit: z.coerce.number().int().min(1).max(53).default(20),
    cursor: z.string().min(1).max(1024).optional(),
    runId: z.string().uuid().optional(),
})
    .strict();
export const autonomousResearchScopeSchema = z
    .object({
    schemaVersion: z.literal("1.0.0"),
    currentPolicy: autonomousResearchScopeSnapshotSchema,
    selectedRun: z
        .object({
        id: z.string().uuid(),
        scopeStatus: z.enum(["RECORDED", "UNKNOWN"]),
        snapshot: autonomousResearchScopeSnapshotSchema.nullable(),
    })
        .strict()
        .nullable(),
    inventory: z
        .object({
        kind: z.literal("POLICY_ROUTES"),
        total: z.literal(53),
        items: z.array(autonomousResearchScopeRouteSchema).max(53),
        nextCursor: z.string().min(1).nullable(),
        coverage: z.literal("NOT_ACCREDITED"),
    })
        .strict(),
    /** Candidate SQL is a capped sample; this endpoint does not inventory global queued/manual work. */
    candidateSelection: z
        .object({ limit: z.literal(2000), completeInventory: z.literal(false) })
        .strict(),
})
    .strict();
//# sourceMappingURL=autonomous-research-scope.js.map